import { omitBy, isNil } from 'lodash-es'
import { useI18n } from 'vue-i18n'

export const useContextFields = (document, text, elements, matches) =>{
  const { t } = useI18n()
  return omitBy({
    [t('result.context.header.document.subcorpus')]: document.subcorpus,
    [t('result.context.header.text.hablante')]: text.hablante,
    [t('result.context.header.text.rol')]: text.rol,
    [t('result.context.header.text.sexo')]: text.sexo,
    [t('result.context.header.text.edad')]: text.edad,
    [t('result.context.header.text.estudios')]: text.estudios,
  }, v => v === '' || isNil(v))
}
